// extracted by mini-css-extract-plugin
export default {"searchLink":"SearchLinkSelectOption-module__searchLink--s9rdc"};